import { hex2RGB } from '../helpers'

// Increments colour values between given start colour and stop colour
const _colourStep = (hex1, hex2, factor = 0.5) => {
  const rgb1 = hex2RGB(hex1)
  const rgb2 = hex2RGB(hex2)

  let rgbOut = rgb1.slice()

  for (let i = 0; i < 3; i++) {
    rgbOut[i] = Math.round(rgbOut[i] + factor * (rgb2[i] - rgb1[i]))
  }

  return rgbOut
}

export const GradientListItem = {
  bind (el, binding) {
    const { value } = binding
    const { start, stop } = value.gradient
    el.style.background = `rgb(${_colourStep(start, stop, 1 / value.stepCount * value.index)})`
  }
}



// WEBPACK FOOTER //
// ./src/directives/GradientListItem.js